import request from '@/utils/request'

// 获取常量
export const getConst = (params: any) =>
  request({
    url: '/constant/' + params,
    method: 'get'
  })

// 常量表
export const getConstant = () =>
  request({
    url: '/constant',
    method: 'get'
  })

// 获取平台信息
export const getEnterprise = () =>
  request({
    url: '/manage/enterprise',
    method: 'get'
  })

// 修改平台信息
export const setEnterprise = (data: any) =>
  request({
    url: '/manage/enterprise',
    method: 'patch',
    data
  })

// 更改 Google Auth
export const setGoogleAuth = (data: any) =>
  request({
    url: '/manage/enterprise/change/google-auth',
    method: 'put',
    data
  })

// 更改 机器人 Google Auth
export const setBotGoogleAuth = (data: any) =>
  request({
    url: '/manage/enterprise/change/bot-google-auth',
    method: 'put',
    data
  })

// 获取产品银行列表
export const getBnakList = (params: any) =>
  request({
    url: '/manage/product/' + params.id + '/bank',
    method: 'get',
    params
  })

// 查找 Telegram 群 ID
export const searchTelegramGroup = (data: any) =>
  request({
    url: '/manage/search-telegram-group',
    method: 'post',
    data
  })

// 发送 Telegram 消息
export const sendTelegramMessage = (data: any) =>
  request({
    url: `/manage/send-msg`,
    method: 'post',
    data
  })

// 提现谷歌验证接口
export const changeAntGoogleAuth = (data: any) =>
  request({
    url: `/manage/ant-google-auth`,
    method: 'put',
    data
  })

// 提现谷歌验证状态接口
export const getAntGoogleAuth = () =>
  request({
    url: `/manage/ant-google-auth`,
    method: 'get'
  })
